import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/tailwind.css"
import lottie from "lottie-web";
import { defineElement } from "@lordicon/element";
import ToastPlugin from './plugins/toast.js';

// define "lord-icon" custom element with default properties
defineElement(lottie.loadAnimation);
Vue.use(ToastPlugin);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
